/* eslint-disable react-hooks/exhaustive-deps */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Autocomplete,
    Box,
    Card,
    Grid,
    IconButton,
    InputAdornment,
    Modal,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import Button from "components/Button/button";
import CurrencyList from "components/CurrencyList/currencyList";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import ViewDocument from "components/ViewDocumentModal/viewDocument";
import CustomText from "components/customtext/customtext";
import SignatureModel from "components/signatureModel/signatureModel";
import { useMaterialUIController } from "context";
import "cropperjs/dist/cropper.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from 'sweetalert2';
import { fetchDefaultSettings, updateDefaultSettingData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { getScreenRight } from "utils/generic";
const errMsg = {
    color: `red`,
    fontSize: `11px`,
};

const cropContainer = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: "80px",
};

const style = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    boxShadow: 24,
    // p: 4,
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
};

let fetchedDefault;
let SCREEN_RIGHT;
let myfile;
const SCREEN_NAME = "Help";


function HelpScreen() {
    const [controller] = useMaterialUIController();
    const { sidenavColor } = controller;
    const [invoicePrefixErr, setInvoicePrefixErr] = useState(false);
    const [invoiceStartNumberErr, setInvoiceStartNumberErr] = useState(false);
    const [quotationPrefixErr, setQuotationPrefixErr] = useState(false);
    const [quotationStartNumberErr, setQuotationStartNumberErr] = useState(false);
    const [rctiPrefixErr, setRctiPrefixErr] = useState(false);
    const [rctiStartNumberErr, setRctiStartNumberErr] = useState(false);
    const [currencyValueErr, setCurrencyValueErr] = useState(false);
    const [hideEyeBtn, setHideEyeBtn] = useState(false);
    const [showUploadedFileFlag, setShowUploadedFileFlag] = useState(false);
    const [showSignatureDialogeFlag, setShowSignatureDialogeFlag] = useState(false);

    //-------UPLOAD LOGO -----------------
    const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
    const [file, setFile] = useState("");
    const [actualFile, setActualFile] = useState("");
    const [logoFileName, setLogoFileName] = useState("");
    const [showEYEBtn, setShowEYEBtn] = useState(false);
    const [showImageFlag, setShowImageFlag] = useState(false);
    const [fileName, setFileName] = useState("");
    const [screenAccess, setScreenAccess] = useState(false);
    const dispatch = useDispatch();

    const [values, setValues] = useState({
        invoicePrefix: "",
        invoiceStartNumber: "",
        creditNotePrefix: "",
        creditNoteNumber: "",
        quotationPrefix: "",
        quotationStartNumber: "",
        rctiPrefix: "",
        rctiStartNumber: "",
        currencyValue: "",
        SignatureFilePath: "",
        defaultLogoFileName: "",
        businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,

    });

    const { tableBorder } = getColorMappings(sidenavColor);

    const handleChange = (name) => (event) => {
        let value = event.target.value;

        if (name === "quotationPrefix" || name === "creditNotePrefix" || name === "invoicePrefix" || name === "rctiPrefix") {
            setValues({ ...values, [name]: value.toUpperCase() });
        } else if (event.target.validity.valid || event.target.validity === undefined) {
            setValues({ ...values, [name]: value });
        }
    };

    const deleteDocument = async () => {
        await axios.post(appConstants.baseURL + 'defaultSettings/deleteBusinessUserSignature', { businessUserID: values.businessUserID }).then((res) => {
            if (res.data.Result_Status) {
                swal('Deleted', res.data.Result_Message, "success")
                setFileName("");
                setHideEyeBtn(false);
            } else {
                swal('Error', res.data.Result_Message, "error")
            }
        }).catch(err => {
            console.log("deleteDocument", err)
        })
    };

    const handleCancel = () => () => {
        setShowSignatureDialogeFlag(false);
        setShowUploadedFileFlag(false)
    };

    const handleSignature = async (val) => {
        try {
            let formData = new FormData();
            formData.append("imageData", val);
            formData.append("businessUserID", values.businessUserID);
            await axios.post(appConstants.baseURL + 'defaultSettings/UpdateBusinessUserSignature', formData,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
                    },
                }
            )
                .then(res => {
                    if (res.data.Result_Status) {
                        Swal.fire({
                            title: "Success",
                            text: res.data.Result_Message,
                            showCancelButton: false,
                            confirmButtonText: "Ok",
                            icon: "success",
                            customClass: { confirmButton: 'okbutton' }
                        });
                        setShowSignatureDialogeFlag(false);
                        setHideEyeBtn(true);
                        setFileName(res.data.Result_Output.signatureFilePath);
                        setValues({ ...values, signatureFilePath: res.data.Result_Output.signatureFilePath });
                    } else {
                        setHideEyeBtn(false);
                        swal("Danger", res.data.Result_Message, "warning");
                    }
                });
        } catch (error) {
            console.error('Error in handleSignature:', error.message);
        }
    };

    const [openCropImageModal, setOpenCropImageModal] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const saveCropedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(file, croppedAreaPixels);
            setFile(croppedImage);
            myfile = await fetch(croppedImage)
                .then((r) => r.blob())
                .then((blobFile) => new File([blobFile], actualFile.name, { type: "image/*" }));
            setActualFile(myfile);
            setLogoFileName(actualFile.name);
            setOpenCropImageModal(false);
            setZoom(1);
        } catch (e) {
            console.error(e);
        }
    }, [croppedAreaPixels]);

    const handleCropCancel = async () => {
        setOpenCropImageModal(false)
        setFile();
        setActualFile();
        setFileName('');
        setLogoFileName('');
        setShowEYEBtn(false)
        setDynamicAspect(1 / 1);
    };
    const saveFile = (e) => {
        try {
            const fileInput = e.target;
            const file = fileInput.files[0];
            if (file) {
                let fileSizeInMB = file.size / (1024 * 1024);
                if (fileSizeInMB > 1) {
                    showResMsg(`File can't be blank or more than 1 MB`, 2000, false);
                } else {
                    setOpenCropImageModal(true);
                    setFile(URL.createObjectURL(file));
                    setActualFile(file);
                    setLogoFileName(file.name);
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setShowImageFlag(false);
                        setShowEYEBtn(true);
                    };
                    reader.readAsDataURL(file);
                }
            } else {
                // Handle the case when no file is selected
                setFile(null);
                setActualFile(null);
                setFileName('');
                setLogoFileName('');
                setShowEYEBtn(false);
            }
            // Reset the file input value to allow re-selection of the same file
            fileInput.value = null;
        } catch (error) {
            console.log("Catch in saveFile=", error);
        }
    };

    useEffect(() => {
        loadData();
        getRight();
    }, [dispatch])

    async function getRight() {
        SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
        // setScreenAccess(SCREEN_RIGHT === 'Full Access' ? true : false);
    }
    const loadData = () => {
        fetchDefaultSettings({ businessUserID: values.businessUserID }, (data) => {
            if (data.Result_Output) {
                fetchedDefault = data.Result_Output;
                setValues(fetchedDefault);
                values.defaultLogoFileName = fetchedDefault.defaultLogoFileName;
                if (values.defaultLogoFileName) {
                    setShowEYEBtn(true);
                    setLogoFileName(fetchedDefault.defaultLogoFileName);
                    setFile(appConstants.baseURL + "employee/viewFile?fileName=" + values.defaultLogoFileName);
                }
                setValues(fetchedDefault);
                if (fetchedDefault.signatureFilePath) {
                    setHideEyeBtn(true)
                    setFileName(fetchedDefault.signatureFilePath);
                }
            }
        }, dispatch)
    }
    const clearErrorStates = () => {
        setInvoicePrefixErr(false);
        setInvoiceStartNumberErr(false);
        setQuotationPrefixErr(false);
        setQuotationStartNumberErr(false);
        setRctiPrefixErr(false);
        setRctiStartNumberErr(false);
        setCurrencyValueErr(false);
    };

    const handleAddData = async () => {
        let mandateFlag = false;
        clearErrorStates();
        mandateFlag = validateField(values.invoicePrefix, setInvoicePrefixErr) || mandateFlag;
        mandateFlag = validateField(values.invoiceStartNumber, setInvoiceStartNumberErr) || mandateFlag;
        mandateFlag = validateField(values.quotationPrefix, setQuotationPrefixErr) || mandateFlag;
        mandateFlag = validateField(values.quotationStartNumber, setQuotationStartNumberErr) || mandateFlag;
        mandateFlag = validateField(values.rctiPrefix, setRctiPrefixErr) || mandateFlag;
        mandateFlag = validateField(values.rctiStartNumber, setRctiStartNumberErr) || mandateFlag;
        mandateFlag = validateField(values.currencyValue, setCurrencyValueErr) || mandateFlag;
        if (mandateFlag) return;
        const formData = new FormData();
        const arrayOfObjects = Object.entries(values).map(([key, value]) => ({ key, value }));
        for (const val of arrayOfObjects) {
            if (val.value) {
                formData.append(val.key, val.value);
            }
        }
        if (actualFile) {
            formData.append('file', actualFile);
            formData.append('fileName', logoFileName);
        }
        updateDefaultSettingData(formData, (data) => {
            showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 3000, data.Result_Status);
            loadData();
        }, dispatch);
    };

    const handleNewChange = (name) => (event, newValue) => {
        if (newValue) {
            setValues({ ...values, [name]: newValue.label, currencyValue: newValue.value });
        }

    };
    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox mt={3} mb={3}>
                <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
                    <Grid item lg={12} xs={12}>
                        <Card sx={{ height: "100%", minHeight: "70vh", boxShadow: "none" }}>
                            <MDBox
                                mx={2}
                                mt={-3}
                                mb={1.5}
                                py={2}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">Help</MDTypography>
                            </MDBox>
                            <Box px={2}>
                                🐦 The Thirsty Crow

                                Once upon a time, on a hot summer day, a crow was flying in search of water. The sun was blazing, and all the ponds and rivers had dried up. The crow was very thirsty and tired.

                                After flying for a long time, he saw a pot lying in a garden. He quickly flew down to see if there was any water inside. He peeped in and saw a little bit of water at the bottom of the pot.

                                The crow tried to drink the water, but his beak could not reach it. He thought hard for a moment. Then he got an idea!

                                He started picking up small pebbles one by one and dropped them into the pot. Slowly, the water began to rise higher and higher. At last, the water came up near the top. The crow happily drank the water and flew away, feeling refreshed and joyful.
                            </Box>


                        </Card>
                    </Grid>
                </Grid>
            </MDBox>


            <ViewDocument
                open={showUploadedFileFlag}
                fileName={`${appConstants.baseURL}defaultSettings/viewUploadedBusinessUserDocument?fileName=/${fileName}`}
                closeModalClick={handleCancel('closeModalClick')}
            />
            {showSignatureDialogeFlag && <SignatureModel open={showSignatureDialogeFlag} sign={handleSignature} handleCancel={handleCancel('handleCancel')} closeModalClick={handleCancel('closeModalClick')} titleMsg="Do you want to Submit the Signature?" />}
            <ShowProfile
                open={showImageFlag}
                fileName={file}
                closeModalClick={() => { setShowImageFlag(false) }}
            />
            <Modal
                open={openCropImageModal}
                onClose={() => { handleCropCancel() }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={style}
            >
                <Grid className="crop-image-wrapper" id="modal-modal-title" >
                    <Grid container spacing={2} style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <Grid style={cropContainer}>
                            <Cropper
                                image={file}
                                crop={crop}
                                zoom={zoom}
                                aspect={dynamicAspect}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                            />
                        </Grid>
                        <Grid container spacing={2} className="crop-control" >
                            <Grid item  >
                                <Typography type="label" style={{ color: "white", fontSize: "12px" }}>
                                    Aspect Ratio
                                </Typography>{" "}
                                <div style={{ display: "flex", justifyContent: 'center', }}>
                                    <select onChange={e => { return setDynamicAspect(parseFloat(e.target.value)); }}  >
                                        <option>1/1</option>
                                        <option value={'1.23'}>1.23/1</option>
                                        <option value={'1.33'}>1.33/1</option>
                                        <option value={'1.43'}>1.43/1</option>
                                        <option value={'1.625'}>1.66/1</option>
                                        <option value={'4.136/2'}>4/2</option>
                                        <option value={'1.7'}>16/9</option>
                                    </select>
                                </div>
                            </Grid>
                            <Grid item >
                                <Typography type="label" style={{ color: "white", textAlign: "center", fontSize: "12px" }}>
                                    Zoom
                                </Typography>&nbsp;
                                <input
                                    type="range"
                                    value={zoom}
                                    min={1}
                                    max={11}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    onChange={(e) => {
                                        setZoom(e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Button className="modalButton cropimgbtn" onClick={saveCropedImage}>
                                    Crop
                                </Button>
                            </Grid>
                            <Grid item style={{ cursor: "pointer", marginRight: "14px", }}>
                                <Button className="modalButton crop-closebtn" onClick={handleCropCancel}>
                                    Close
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Modal>
        </DashboardLayout >
    );
}

export default HelpScreen;
